module.exports = __webpack_public_path__ + "static/media/logo-cineicc.08d27b52.png";